import { Component, OnInit } from "@angular/core";
import { CookieService } from "ngx-cookie-service";
import { Router, ActivatedRoute } from "@angular/router";
import { CommonService } from "../common.service";
import { NgxSpinnerService } from "ngx-spinner";
import { CommonVariablesService } from "./../common-variables.service";
import { DatePipe } from "@angular/common";
import { noop, Observable, Observer, of } from "rxjs";
import { map, switchMap, tap } from "rxjs/operators";
//import { HttpClient, HttpHeaders } from '@angular/common/http';
import { from } from "rxjs";

@Component({
	selector: "app-header",
	templateUrl: "./header.component.html",
	styleUrls: ["./header.component.css"],
})
export class HeaderComponent implements OnInit {
	headerData: Observable<any>;
	userName: string;
	email: string;
	noResult = false;
	//selected: string;
	getUserType: boolean;
	userLastLogin: string = "";
	myLocalDataList: any = [];
	pageContent: any;
	bulkPageSubscription: any;
	lastLogin: any = "";
	isLoggedIn = sessionStorage.getItem("token") ? true : false;
	issearchShow = true;
	/* isLoggedIn =window.localStorage.getItem('token') ? true : false; */

	constructor(
		private cookie: CookieService,
		private router: Router,
		public commonService: CommonService,
		public commonVariablesService: CommonVariablesService,
		private activatedRoute: ActivatedRoute,
		private spinner: NgxSpinnerService,
		private datePipe: DatePipe
	) {}
	async ngOnInit() {
		this.headerData = new Observable((observer: Observer<string>) => {
			observer.next(this.commonVariablesService.selected);
		}).pipe(
			switchMap((query: string) => {
				this.commonVariablesService.gcPolicyNoFromHeaderSearch = query;

				if (query && query.length >= 6) {
					return from(this.commonService.formMasterPolicyList("Header")).pipe(
						map((data: any) => data || []),
						tap(
							() => noop,
							(err) => {
								console.log("Something goes wrong");
							}
						)
					);
				}

				/* 
				if (query && query.length >= 6) {
					setTimeout(() => {
						this.spinner.hide();
					}, 7000);
				}
				 */
				/* return of([]); // Don't remove */
				return [];
			})
		);

		let tmpUserProfile = window.localStorage.getItem("userProfile");
		var getUserType = this.commonService.decryptData(tmpUserProfile);
		// if(getUserType == 'marineclaims' && sessionStorage.getItem('token') || getUserType == 'helpdesk'){
		if (getUserType == "helpdesk") {
			//this.issearchShow = false;
			this.issearchShow = true;
		} else this.issearchShow = sessionStorage.getItem("token") ? true : false;
		if (this.isLoggedIn) {
			const ret = this.commonVariablesService.productId
				? true
				: await this.commonService.commonLOBvalues();
			if (!ret) {
				this.router.navigate(["/login"]);
			}
			/* this.userName = this.cookie.get('name'); */
			this.userName = window.localStorage.getItem("name");
			/* this.email = this.cookie.get('email'); */
			this.email = window.localStorage.getItem("email");
			/* this.userLastLogin = this.cookie.get('lastLogin'); */
			this.userLastLogin = window.localStorage.getItem("lastLogin");
			if (this.userLastLogin)
				this.lastLogin = this.datePipe.transform(
					new Date(this.userLastLogin + " GMT").toISOString(),
					"dd-MM-yyyy HH:mm:ss"
				);
			/* let tmpUserType = this.cookie.get('userType'); */
			let tmpUserType = window.localStorage.getItem("userType");
			let tmpDecodeType = this.commonService.decryptData(tmpUserType);
			if (tmpDecodeType == "tagicUser") {
				this.getUserType = false;
			} else {
				this.getUserType = true;
			}
			if (this.issearchShow) {
				// this.loadDropdownValues();
			}
		}
	}

	/*
	 * Created By : Sharann N
	 * Description : navigate to login page.
	 *********************************************/
	logout() {
		this.cookie.deleteAll();
		window.localStorage.clear();
		sessionStorage.clear();
		this.router.navigate(["/login"]);
	}

	/*
	 * Created By : Sharann N
	 * Description : will trigger when no result for entered text in search.
	 *********************************************/
	typeaheadNoResults(event: boolean): void {
		if (this.commonVariablesService.gcPolicyNoFromHeaderSearch.length >= 6) {
			this.noResult = event;
		}
	}

	/*
	 * Created By : Sharann N
	 * Description : navigate to declaration page on dropdown select.
	 *********************************************/
	async typeaheadOnSelect(e: any, isManuallyTrigger: boolean = false) {
		this.commonVariablesService.selected = e.value
			? e.value.split("~$")[1]
			: "";
		await this.commonService.setCertificateParmsToLStorage(e);

		this.bulkPageSubscription = this.activatedRoute.params.subscribe((val) => {
			this.pageContent = Number(val.id) || 0;
		});
		/* if(this.pageContent == '1' && !isManuallyTrigger){
            window.location.reload();
        }else{
            this.router.navigate(['/declaration', 1]);
        } */
		this.commonService.passValue({ id: 1 });
		this.router.navigate(["/declaration", 1]);
	}

	/*
	 * Created By : Sharann N
	 * Description : load master policies in dropdown.
	 *********************************************/
	async loadDropdownValues() {
		this.spinner.show();
		// await this.commonService.formMasterPolicyList('Header');
		// if (this.myLocalDataList.length == 0)
		if (this.commonService.gcPolicyList.length == 0) {
			setTimeout(() => {
				this.spinner.hide();
			}, 7000);
			return;
		}
		const tmpUrl = this.router.url.split("/");
		/* const tmpUserProfile = this.cookie.get('userProfile'); */
		const tmpUserProfile = window.localStorage.getItem("userProfile");
		const getUserType = this.commonService.decryptData(tmpUserProfile);
		if (
			tmpUrl[1] == "declaration" &&
			Number(tmpUrl[2]) <= 1 &&
			getUserType != "underwriter"
		) {
			if (this.commonService.gcPolicyList.length == 1) {
				this.typeaheadOnSelect(
					{
						value: this.commonService.gcPolicyList[0].search_val,
						item: this.commonService.gcPolicyList[0],
					},
					true
				);
			}
			/* if (this.myLocalDataList.length == 1) {
				this.typeaheadOnSelect({
					value: this.myLocalDataList[0].search_val,
					item: this.myLocalDataList[0]
				}, true);
			} */
		}
		const isDeclarationInitialPage =
			tmpUrl[1] == "declaration" && Number(tmpUrl[2]) == 0 ? true : false;
		if (isDeclarationInitialPage) {
			this.spinner.show();
		}
		if (tmpUrl[1] == "declaration") {
			// (Number(tmpUrl[2]) == 0 && this.myLocalDataList.length == 1) ? this.typeaheadOnSelect({value: this.myLocalDataList[0].search_val}) : '';
			if (Number(tmpUrl[2])) {
				const header = JSON.parse(
					window.localStorage.getItem("declaration-header") || "{}"
				);
				this.commonVariablesService.selected = header.header_policy || "";
			}
		}

		/* const tmpUserProfile = this.cookie.get('userProfile'); */
		/* const tmpUserProfile = window.localStorage.getItem('userProfile');
		const getUserType = this.commonService.decryptData(tmpUserProfile);
		if (tmpUrl[1] == 'declaration' && Number(tmpUrl[2]) <= 1 && getUserType != 'underwriter') {
			if (this.commonService.gcPolicyList.length == 1) {
				this.typeaheadOnSelect({
					value: this.commonService.gcPolicyList[0].search_val,
					item: this.commonService.gcPolicyList[0]
				}, true);
			}
			/* if (this.myLocalDataList.length == 1) {
				this.typeaheadOnSelect({
					value: this.myLocalDataList[0].search_val,
					item: this.myLocalDataList[0]
				}, true);
			} /
		} */
		// (isDeclarationInitialPage) ? this.spinner.hide() : '';
		setTimeout(() => {
			this.spinner.hide();
		}, 7000);
	}
}
